__turbopack_context__.v({
  "towelAccessory": "AvatarOnBeachTowel-module__jcJp1G__towelAccessory",
});
